import React, { FunctionComponent } from "react";
import { Field, FieldAttributes } from "formik";
import { TextField as TextInput } from "formik-mui";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { omit } from "lodash";
import { useTheme } from "@mui/material";
import { TextMaskInput } from "./TextMaskInput";

export const TextField: FunctionComponent<ITextFieldProps> = ({
  enterAction,
  forceWhite,
  autocomplete,
  ...props
}) => {
  const theme = useTheme();
  const inputProps =
    props.component === "textarea"
      ? undefined
      : {
          InputProps: {
            className: classNames(props.inputstyles, styles.input),
            readOnly: props.readOnly,
            autoComplete: autocomplete,
            style: { color: forceWhite ? "white" : theme.palette.primary.main }
          }
        };
  return (
    <Field
      className={classNames(
        styles.textField,
        props.className,
        props.mask ? styles.maskedStyle : undefined
      )}
      component={props.mask ? TextMaskInput : TextInput}
      variant={"outlined"}
      size={"small"}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
          if (enterAction) {
            event.preventDefault();
            enterAction();
          }
        }
      }}
      {...inputProps}
      {...omit(props, "className", "inputstyles")}
    />
  );
};

export interface ITextFieldProps extends FieldAttributes<any> {
  className?: string;
  mask?: any;
  readOnly?: boolean;
  enterAction?: () => void;
  forceWhite?: boolean;
  autocomplete?: string;
}
